import "./SelfServe.css";
import "react-hook-theme/dist/styles/style.css";
import React, { useEffect, useState, lazy, Suspense } from "react";
import { Box, Grid, Divider, Button } from "@mui/material";
import FwSymbol from '../../media/site_media/illustrations/withme/grey-logo.png';
import axios from 'axios';
import Modal from "@mui/material/Modal";
import CircularProgress from '@mui/material/CircularProgress';
import { FcGoogle } from "react-icons/fc";
import { logApiRequest } from '../common/mixpanelInterface';
import { Helmet } from 'react-helmet';
import "../../css/Influencer.css";
import { FaApple } from "react-icons/fa";
import AndroidPlaystore from '../../media/site_media/social_icons/play-store.png';
import AppleAppstore from '../../media/site_media/social_icons/apple-store.png';
import { useSearchParams } from "react-router-dom";
import { gtag, install } from 'ga-gtag';
import { useDebouncedResize } from '../../hooks/useDebouncedResize';
import { useIdle } from '../../hooks/useIdle';
import LazySection from '../common/LazySection';
import Hero from "./SalesPageComponents/Hero";
import HubVsAgents from "./SalesPageComponents/HubVsAgents";
import OutcomePromise from "./SalesPageComponents/OutcomePromise";
import AgentFeatures from "./SalesPageComponents/AgentFeatures";
import CounterSection from "./SalesPageComponents/CounterSection";
import waitUntilConditionIsTrue from '../../utils/waitUntilConditionIsTrue';
import { useTranslation } from 'react-i18next';
const PreloadHeroImage = 'https://openaccessimages.s3.eu-west-2.amazonaws.com/sales-page-assets/images/hero-features-william.webp';
const OnboardingNavbar = lazy(() => import("../Navigation/OnboardingNavbar"));

const PopupModal = lazy(() => import('react-calendly').then(module => ({ default: module.PopupModal })));
const PricingModal = lazy(() => import('./PricingModal'));
const AppleLogin = lazy(() => import('react-apple-login'));
const Footer = lazy(() => import("../Navigation/Footer"));

// New visual sections (lazy)
const Stories = lazy(() => import("./SalesPageComponents/Stories"));
const Testimonials = lazy(() => import("./SalesPageComponents/Testimonials"));
const FinalCTA = lazy(() => import("./SalesPageComponents/FinalCTA"));

const paths = require('../../paths.json');
const INTERCOM_APP_ID = 'lfsiny3p';

async function sendSalesPageView(ip, fbclid) {
   try {
      await axios({
         method: 'post',
         url: `${paths.BACKEND_URL}api/send_fb_conversion_event`,
         data: JSON.stringify({
            event_name: 'SalesPageView',
            source_url: window.location.href,
            ip_address: ip || '',
            fbclid: fbclid || '',
         }),
         headers: { 'Content-Type': 'application/json' },
         withCredentials: true,
      });
   } catch (error) {}
}

const modalStyle = {
    display: 'flex',
    height: 'auto',
    // bgcolor: 'rgba(0,0,0,1)',
    minHeight: '100vh',
    minWidth: '100vw',
    overflowY: 'hidden',
    outline: 'none',
    zIndex: '9999',
};
if ('requestIdleCallback' in window) {
    window.requestIdleCallback(() => install('G-B48N4YEGNE'));
} else {
    setTimeout(() => install('G-B48N4YEGNE'), 2000);
}

const openInNewTab = (url) => {
    const newWindow = window.open(url, '_blank', 'noopener,noreferrer')
    if (newWindow) newWindow.opener = null
 }



export default function SalesPage(props) {
    const { t, i18n } = useTranslation();
    const { width: windowWidth } = useDebouncedResize(0);
    const isIdle = useIdle();
    const [displayName, setDisplayName] = useState('')
    const [userEmail, setUserEmail] = useState('')
    const [emailField, setEmailField] = useState('')
    const [submitError, setSubmitError] = useState(false)
    const [emailSubmit, setEmailSubmit] = useState({ open: false, severity: 'success', message: '' })
    const [load_user_data] = useState((props.load_user_data === false) ? false : true);
    const [current_user, setCurrentUser] = useState('');
    const [current_user_email, setCurrentUserEmail] = useState('');
    const [influencer_bool, setInfluencerBool] = useState('');
    const [intercom_verify_key, setIntercomVerifyKey] = useState('');
    const [hidden_influencer, setHiddenInfluencer] = useState('');
    const [waiting_list_influencer, setWaitingListInfluencer] = useState('')
    const [current_user_icon, setCurrentUserIcon] = useState('');
    const [pre_influencer, setPreInfluencer] = useState(false);
    const [logged_in, setLoggedIn] = useState(false);
    const [calendlyModal, setCalendlyModal] = useState(false);
    const [registerIsLoading, setRegisterIsLoading] = useState(false);
    const [searchParams] = useSearchParams();
    const [referralId, setReferralId] = useState('');
    const [referralCode, setReferralCode] = useState('');
    const [passiveReferralId, setPassiveReferralId] = useState('');
    const [user_subscriptions, setUserSubs] = useState([])
    const [n_user_subscriptions, setNUserSubs] = useState(0)
    const [utmSource, setUtmSource] = useState('');
    const [utmMedium, setUtmMedium] = useState('');
    const [utmCampaign, setUtmCampaign] = useState('');
    const [utmContent, setUtmContent] = useState('');
    const [utmTerm, setUtmTerm] = useState('');
    const [pricingModal, setPricingModal] = useState(false)
    const [appModal, setAppModal] = useState(false)

    const handleAppModalOpen = () => {
        setAppModal(true)
    }

    const handleAppModalClose = () => {
        setAppModal(false)
    }


    // Styles
    const sectionHeader = {
        color: 'var(--brand-color)',
        fontSize: '16px',
        textTransform: 'uppercase',
        fontWeight: '800',
    }

    const mainHeader = {
        color: '#222222',
        fontSize: windowWidth < 600 ? '30px' : '38px',
        textTransform: 'uppercase',
        fontWeight: '600',
        margin: '0px',
        maxWidth: '900px',
        textAlign: 'center',
        marginBottom: '20px',
    }

    const mainDescription = {
        color: '#6E89AF',
        fontSize: windowWidth < 600 ? '14px' : '16px',
        fontWeight: '400',
        margin: '0px 0px',
        maxWidth: '900px',
        textAlign: 'center',
        marginBottom: '20px',
        lineHeight: '1.5',
    }

    const launchIntercom = React.useCallback(() => {
        const intercomLanguage = (i18n.resolvedLanguage || i18n.language || 'en').split('-')[0];
        const userOpts = logged_in ? {
          name: current_user,
          email: current_user_email,
          user_hash: intercom_verify_key,
          is_influencer: influencer_bool,
          is_logged_in: logged_in,
          language_override: intercomLanguage,
          avatar: { type: 'avatar', image_url: current_user_icon },
        } : {
          language_override: intercomLanguage,
        };
      
        if (window.deferIntercom) window.deferIntercom();
      
        (function wait() {
          if (window.Intercom && typeof window.Intercom === 'function') {
            if (!window.__intercomBooted) {
              window.Intercom('boot', {
                app_id: INTERCOM_APP_ID,
                api_base: 'https://api-iam.intercom.io',
                hide_default_launcher: true,
                ...userOpts,
              });
              window.__intercomBooted = true;
            } else if (logged_in) {
              window.Intercom('update', userOpts);
            }
            window.Intercom('show');
          } else {
            setTimeout(wait, 50);
          }
        })();
      }, [logged_in, current_user, current_user_email, intercom_verify_key, influencer_bool, current_user_icon, i18n.language, i18n.resolvedLanguage]);

    // Capture fbclid and append to internal links
    useEffect(() => {
        const urlParams = new URLSearchParams(window.location.search);
        const urlFbclid = urlParams.get('fbclid');
        if (urlFbclid) {
            localStorage.setItem('fbclid', 'fb.1.' + Date.now() + '.' + urlFbclid);
        }
        const storedFbclid = urlFbclid || localStorage.getItem('fbclid');
        if (storedFbclid) {
            const handleClick = (e) => {
                const link = e.target.closest('a[href]');
                if (!link) return;
                const href = link.getAttribute('href');
                if (href && href.startsWith('/') && !href.includes('fbclid')) {
                    e.preventDefault();
                    const sep = href.includes('?') ? '&' : '?';
                    window.location.assign(href + sep + 'fbclid=' + encodeURIComponent(storedFbclid));
                }
            };
            document.addEventListener('click', handleClick);
            return () => document.removeEventListener('click', handleClick);
        }
    }, []);

    useEffect(() => {
        if ((paths.URL === "https://fitwith.io/") || (paths.URL === "https://withme.so/")){
            const storedFbclid = localStorage.getItem('fbclid') || null;
            // Only include IP address if user has given advertisement consent (UK GDPR)
            if (window.adConsentOK && window.adConsentOK()) {
                axios.get("https://api64.ipify.org?format=json")
                .then(res => sendSalesPageView(res.data.ip, storedFbclid))
                .catch(() => sendSalesPageView(null, storedFbclid));
            } else {
                // Always send fbclid event, just without IP
                sendSalesPageView(null, storedFbclid);
                // If consent is given later, re-send with IP
                const handler = (e) => {
                    if (e.detail && e.detail.accepted && e.detail.accepted.includes('advertisement')) {
                        axios.get("https://api64.ipify.org?format=json")
                        .then(res => sendSalesPageView(res.data.ip, storedFbclid))
                        .catch(() => {});
                        document.removeEventListener('cookieyes_consent_update', handler);
                    }
                };
                document.addEventListener('cookieyes_consent_update', handler);
                return () => document.removeEventListener('cookieyes_consent_update', handler);
            }
        }
    }, [searchParams])


    // run tracking script (deferred until idle to avoid blocking LCP)
    useEffect(() => {
        if (!isIdle) return;
        
        const scriptId = 'vtag-ai-js';
        let idleHandle = null;
        const inject = () => {
            if (document.getElementById(scriptId)) return;
            const script = document.createElement('script');
            script.id = scriptId;
            script.async = true;
            script.defer = true;
            script.src = 'https://r2.leadsy.ai/tag.js';
            script.setAttribute('data-pid', '3KYmvy8u5QmXukLd');
            script.setAttribute('data-version', '062024');
            document.body.appendChild(script);
        };
        if ('requestIdleCallback' in window) {
            idleHandle = window.requestIdleCallback(inject, { timeout: 5000 });
        } else {
            // fallback after a short delay
            idleHandle = setTimeout(inject, 2500);
        }
        return () => {
            if (typeof idleHandle === 'number') clearTimeout(idleHandle);
            else if (idleHandle && window.cancelIdleCallback) window.cancelIdleCallback(idleHandle);
            const existingScript = document.getElementById(scriptId);
            if (existingScript) existingScript.remove();
        };
    }, [isIdle]);

    // get the user information
    useEffect(() => {
        try {
            const saved = localStorage.getItem("userEmail");
            const initialValue = JSON.parse(saved);
            setUserEmail(initialValue);
        } catch {
            setUserEmail('');
        }
        new Promise(async (resolve, reject) => {
            if (load_user_data === true) {
                const res = await axios({
                    method: 'get',
                    url: paths.BACKEND_URL + 'api/intercom_user_verify_extra',
                    withCredentials: true,
                })
                if (res.data) {
                    // username
                    setCurrentUser(res.data.username);
                    // diplay name
                    setDisplayName(res.data.display_name)
                    // email
                    setCurrentUserEmail(res.data.email);
                    // intercom key
                    setIntercomVerifyKey(res.data.user_key);
                    // is influencer
                    setInfluencerBool(res.data.influencer_bool);
                    // is pre influencer
                    setPreInfluencer(res.data.pre_influencer);
                    // is waitlist influencer
                    setWaitingListInfluencer(res.data.waiting_list_influencer);
                    // user icon image
                    setCurrentUserIcon(res.data.current_user_icon);
                    // hidden influencer
                    setHiddenInfluencer(res.data.hidden_influencer);
                    // user subs
                    setUserSubs(res.data.user_subscriptions);
                    // number of user subs
                    setNUserSubs(res.data.n_user_subscriptions);
                    setReferralId(searchParams.get("id"));
                    setReferralCode(searchParams.get("code"));
                    setPassiveReferralId(searchParams.get("passive_id"));
                    setUtmSource(searchParams.get("utm_source"));
                    setUtmMedium(searchParams.get("utm_medium"));
                    setUtmCampaign(searchParams.get("utm_campaign"));
                    setUtmContent(searchParams.get("utm_content"));
                    setUtmTerm(searchParams.get("utm_term"));
                    if (String(searchParams.get("creators")) === 'true') {
                        window.location.assign(window.location.href + '#creators')
                    }
                    // set logged in
                    if (res.data.username !== '') {
                        setLoggedIn(true)
                    } else {
                        setLoggedIn(false)
                    }
                }
            } else {
                setReferralId(searchParams.get("id"));
                setReferralCode(searchParams.get("code"));
                setPassiveReferralId(searchParams.get("passive_id"));
                setUtmSource(searchParams.get("utm_source"));
                setUtmMedium(searchParams.get("utm_medium"));
                setUtmCampaign(searchParams.get("utm_campaign"));
                setUtmContent(searchParams.get("utm_content"));
                setUtmTerm(searchParams.get("utm_term"));
            }
        })
    }, [load_user_data]);

    // const handleChange = (panel) => (event, newExpanded) => setExpanded(newExpanded ? panel : false);
    // const handleTabs = (event, newValue) => setValue(newValue);
    const handlePricingModalOpen = () => setPricingModal(true);
    const handlePricingModalClose = () => setPricingModal(false);


    // // Save user email input to local storage to be accessed on register page
    useEffect(() => {
        // storing input name
        localStorage.setItem("userEmail", JSON.stringify(userEmail));
    }, [userEmail]);


    useEffect(() => {
        setEmailField(document.querySelectorAll('.email-field'));
    }, []);

    // Scroll to hash anchor (e.g. #how) after page loads
    useEffect(() => {
        if (window.location.hash) {
            const id = window.location.hash.replace('#', '');
            const tryScroll = (attempts = 0) => {
                const el = document.getElementById(id);
                if (el) {
                    el.scrollIntoView({ behavior: 'smooth', block: 'start' });
                    window.history.replaceState(null, '', window.location.pathname + window.location.search);
                } else if (attempts < 10) {
                    setTimeout(() => tryScroll(attempts + 1), 200);
                }
            };
            tryScroll();
        }
    }, []);

    const handleSubmit = (e) => {
        e.preventDefault()
        setEmailSubmit({
            open: false,
            severity: submitError ? 'error' : 'success',
            message: ''
        })
        setSubmitError(false)
        const regex = /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
        if (!userEmail || regex.test(userEmail) === false) {
            setEmailSubmit({
                open: true,
                severity: 'error',
                message: t('selfServe.pleaseEnterValidEmail')
            })
            setSubmitError(true)
        }
        else {
            const form_data = new FormData()
            const emailRecipient = 'markgray@fitwithofficial.com'
            form_data.append('email', userEmail)
            form_data.append('recipient', emailRecipient)
            const startTime = performance.now();
            axios(
                {
                    method: 'post',
                    url: paths.BACKEND_URL + 'api/landing_page_submit_email',
                    data: form_data,
                    headers: {
                        'Content-type': 'application/json',
                    },
                    withCredentials: true
                }).then(res => {
                    if (res.data.success) {
                        logApiRequest(paths.BACKEND_URL + 'api/landing_page_submit_email', performance.now() - startTime)
                        setEmailSubmit({
                            open: true,
                            severity: 'success',
                            message: t('selfServe.doneWellBeInTouch')
                        })
                        emailField[0].value = ''
                        emailField[1].value = ''
                        window.location.assign('https://fitwith.pipedrive.com/scheduler/ajvdl4sO/meeting-default')
                    }
                    else {
                        setEmailSubmit({
                            open: true,
                            severity: 'error',
                            message: t('selfServe.oopsError')
                        })
                        setSubmitError(true)
                    }
                })
        }
    }



    return (
        <div className="landing_body sp-page" style={{ background: '#fff' }}>
            <Grid
                onKeyDown={(e) => {
                    if (e.key === 'Enter') {
                        e.stopPropagation();
                        e.preventDefault();
                        let direct_url = ''
                        if (logged_in === true) {
                            if (referralId != null) {
                                direct_url = '/become-a-creator/quick-signup?id=' + referralId
                            } else if (passiveReferralId != null) {
                                direct_url = '/become-a-creator/quick-signup?passive_id=' + passiveReferralId
                            } else {
                                direct_url = '/become-a-creator/quick-signup'
                            }
                            if (utmSource !== null) {
                                if (direct_url.includes('?')) {
                                    direct_url = direct_url + '&utm_source=' + utmSource
                                } else {
                                    direct_url = direct_url + '?utm_source=' + utmSource
                                }
                            }
                            if (utmMedium !== null) {
                                if (direct_url.includes('?')) {
                                    direct_url = direct_url + '&utm_medium=' + utmMedium
                                } else {
                                    direct_url = direct_url + '?utm_medium=' + utmMedium
                                }
                            }
                            if (utmCampaign !== null) {
                                if (direct_url.includes('?')) {
                                    direct_url = direct_url + '&utm_campaign=' + utmCampaign
                                } else {
                                    direct_url = direct_url + '?utm_campaign=' + utmCampaign
                                }
                            }
                            if (utmContent !== null) {
                                if (direct_url.includes('?')) {
                                    direct_url = direct_url + '&utm_content=' + utmContent
                                } else {
                                    direct_url = direct_url + '?utm_content=' + utmContent
                                }
                            }
                            if (utmTerm !== null) {
                                if (direct_url.includes('?')) {
                                    direct_url = direct_url + '&utm_term=' + utmTerm
                                } else {
                                    direct_url = direct_url + '?utm_term=' + utmTerm
                                }
                            }
                            const _fbclid = new URLSearchParams(window.location.search).get('fbclid') || localStorage.getItem('fbclid');
                            if (_fbclid) {
                                direct_url += (direct_url.includes('?') ? '&' : '?') + 'fbclid=' + encodeURIComponent(_fbclid);
                            }
                            window.location.assign(direct_url)
                        } else {
                            const regex = /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
                            if (!userEmail || regex.test(userEmail) === false) {
                                setEmailSubmit({
                                    open: true,
                                    severity: 'error',
                                    message: t('selfServe.pleaseEnterValidEmail')
                                })
                                setSubmitError(true);
                            } else {
                                if (referralId != null) {
                                    direct_url = '/become-a-creator/quick-signup?id=' + referralId
                                } else if (passiveReferralId != null) {
                                    direct_url = '/become-a-creator/quick-signup?passive_id=' + passiveReferralId
                                } else {
                                    direct_url = '/become-a-creator/quick-signup'
                                }
                                if (utmSource !== null) {
                                    if (direct_url.includes('?')) {
                                        direct_url = direct_url + '&utm_source=' + utmSource
                                    } else {
                                        direct_url = direct_url + '?utm_source=' + utmSource
                                    }
                                }
                                if (utmMedium !== null) {
                                    if (direct_url.includes('?')) {
                                        direct_url = direct_url + '&utm_medium=' + utmMedium
                                    } else {
                                        direct_url = direct_url + '?utm_medium=' + utmMedium
                                    }
                                }
                                if (utmCampaign !== null) {
                                    if (direct_url.includes('?')) {
                                        direct_url = direct_url + '&utm_campaign=' + utmCampaign
                                    } else {
                                        direct_url = direct_url + '?utm_campaign=' + utmCampaign
                                    }
                                }
                                if (utmContent !== null) {
                                    if (direct_url.includes('?')) {
                                        direct_url = direct_url + '&utm_content=' + utmContent
                                    } else {
                                        direct_url = direct_url + '?utm_content=' + utmContent
                                    }
                                }
                                if (utmTerm !== null) {
                                    if (direct_url.includes('?')) {
                                        direct_url = direct_url + '&utm_term=' + utmTerm
                                    } else {
                                        direct_url = direct_url + '?utm_term=' + utmTerm
                                    }
                                }
                                const _fbclid2 = new URLSearchParams(window.location.search).get('fbclid') || localStorage.getItem('fbclid');
                                if (_fbclid2) {
                                    direct_url += (direct_url.includes('?') ? '&' : '?') + 'fbclid=' + encodeURIComponent(_fbclid2);
                                }
                                window.location.assign(direct_url)
                            }
                        }
                    }
                }}
            >
                <Suspense fallback={<></>}>
                    <OnboardingNavbar
                        showLanguageSelector={true}
                        logged_in={logged_in}
                        launchIntercom={launchIntercom}
                        current_user_icon={current_user_icon}
                        pre_influencer={pre_influencer}
                        current_user={current_user}
                        windowWidth={windowWidth}
                        handlePricingModalOpen={() => handlePricingModalOpen()}
                        handlePricingModalClose={() => handlePricingModalClose()}
                        handleAppModalOpen={() => handleAppModalOpen()}
                        handleAppModalClose={() => handleAppModalClose()}
                        displayName={displayName}
                        influencer_bool={influencer_bool}
                        hidden_influencer={hidden_influencer}
                        waiting_list_influencer={waiting_list_influencer}
                        user_subscriptions={user_subscriptions}
                        n_user_subscriptions={n_user_subscriptions}
                        setCalendlyModal={(bool) => setCalendlyModal(bool)}
                        utmSource={utmSource}
                        utmMedium={utmMedium}
                        utmCampaign={utmCampaign}
                        utmTerm={utmTerm}
                        utmContent={utmContent}
                        referralId={referralId}
                        passiveReferralId={passiveReferralId}
                        referralCode={referralCode}
                    /></Suspense>
                <Helmet>
                    <title>{t('salesPage.metaTitle')}</title>
                    <link rel="preload" as="image" href={PreloadHeroImage} imagesrcset={`${PreloadHeroImage} 800w`} fetchpriority="high" />
                    <link rel="stylesheet" href="https://fonts.googleapis.com/css2?family=Instrument+Serif:ital@0;1&display=swap" />
                </Helmet>

                {/* 1. Hero */}
                <Hero
                    windowWidth={windowWidth}
                    pre_influencer={pre_influencer}
                    userEmail={userEmail}
                    setUserEmail={(e) => setUserEmail(e)}
                    handleSubmit={(e) => handleSubmit(e)}
                    emailSubmit={emailSubmit}
                    setEmailSubmit={setEmailSubmit}
                    submitError={submitError}
                    setRegisterIsLoading={(bool) => setRegisterIsLoading(bool)}
                    logged_in={logged_in}
                    influencer_bool={influencer_bool}
                    current_user={current_user}
                    utmSource={utmSource}
                    utmMedium={utmMedium}
                    utmCampaign={utmCampaign}
                    utmTerm={utmTerm}
                    utmContent={utmContent}
                    referralId={referralId}
                    passiveReferralId={passiveReferralId}
                />

                {/* 2. Hub vs Agents (pricing) */}
                <HubVsAgents
                    windowWidth={windowWidth}
                    logged_in={logged_in}
                    pre_influencer={pre_influencer}
                    influencer_bool={influencer_bool}
                    current_user={current_user}
                    utmSource={utmSource}
                    utmMedium={utmMedium}
                    utmCampaign={utmCampaign}
                    utmTerm={utmTerm}
                    utmContent={utmContent}
                    referralId={referralId}
                    passiveReferralId={passiveReferralId}
                />

                {/* 3. Outcome Promise */}
                <OutcomePromise windowWidth={windowWidth} />

                {/* 4. Agent Features */}
                <AgentFeatures windowWidth={windowWidth} />

                {/* 5. Counter + Social Proof */}
                <CounterSection windowWidth={windowWidth} />

                {/* 6. Creator Stories */}
                <LazySection fadeDelay={150} fallback={<div style={{ minHeight: '400px' }} />}>
                    <Stories
                        windowWidth={windowWidth}
                        logged_in={logged_in}
                        pre_influencer={pre_influencer}
                        influencer_bool={influencer_bool}
                        current_user={current_user}
                        utmSource={utmSource}
                        utmMedium={utmMedium}
                        utmCampaign={utmCampaign}
                        utmTerm={utmTerm}
                        utmContent={utmContent}
                        referralId={referralId}
                        passiveReferralId={passiveReferralId}
                    />
                </LazySection>

                {/* 7. Testimonials */}
                <LazySection fadeDelay={150} fallback={<div style={{ minHeight: '400px' }} />}>
                    <Testimonials windowWidth={windowWidth} />
                </LazySection>

                {/* 8. Final CTA */}
                <LazySection fadeDelay={150} fallback={<div style={{ minHeight: '200px' }} />}>
                    <FinalCTA
                        windowWidth={windowWidth}
                        logged_in={logged_in}
                        pre_influencer={pre_influencer}
                        influencer_bool={influencer_bool}
                        current_user={current_user}
                        utmSource={utmSource}
                        utmMedium={utmMedium}
                        utmCampaign={utmCampaign}
                        utmTerm={utmTerm}
                        utmContent={utmContent}
                        referralId={referralId}
                        passiveReferralId={passiveReferralId}
                    />
                </LazySection>

                {/* 9. Footer */}
                {
                    windowWidth >= 900 ?
                        <LazySection fadeDelay={150} fallback={<div style={{ minHeight: '300px' }} />}>
                            <Footer
                                handleAppModalOpen={() => handleAppModalOpen()}
                                handleAppModalClose={() => handleAppModalClose()}
                                launchIntercom={launchIntercom}
                                handlePricingModalOpen={() => handlePricingModalOpen()}
                                handlePricingModalClose={() => handlePricingModalClose()}
                                />
                        </LazySection>
                        :
                        <Grid container
                            direction='row'
                            alignItems='center'
                            justifyContent='center'
                            backgroundColor='#fff'
                            style={{
                                marginLeft: '10px',
                                width: '95%',
                            }}>
                            <Grid xs={12}>
                                <Divider sx={{ width: '100%', marginBottom: '15px' }} flexItem>
                                </Divider>
                            </Grid>

                            <Grid xs={0.5}>
                            <img alt={t('selfServe.withMeLogo')} src={FwSymbol} style={{ width: 'auto', height: '22px' }} />
                            </Grid>

                            <Grid xs={11.5} sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                                <Button variant="contained" disableElevation onClick={() => {
                                    window.Intercom('show');
                                }}
                                    sx={{
                                        padding: '4px 10px', display: 'inline-block', marginLeft: 'auto', marginRight: '0px', borderRadius: '50px', textTransform: 'none',
                                        backgroundColor: '#fff', border: 'solid #AFBED3 1px', color: '#AFBED3', '&:hover': { backgroundColor: '#f1f1f1' }
                                    }}
                                    type="submit">
                                    <span className="fa fa-search" style={{ fontWeight: '600', fontSize: '11px' }}>{t('footer.needHelp')}</span>
                                </Button>
                            </Grid>
                            <Grid xs={12} style={{ display: 'flex', justifyContent: 'flex-start', flexDirection: 'column' }}>
                                <div style={{ display: 'inline-block' }}>
                                    <span
                                        className={'footer_smaller_items'}
                                        style={{ fontSize: '11px', color: '#6D89AF', cursor: 'pointer', display: 'block', marginBottom: '5px' }}
                                        onClick={() => openInNewTab('/privacy_policy')}
                                    >
                                        {t('footer.privacyPolicy')}
                                    </span>
                                    <span
                                        className={'footer_smaller_items'}
                                        style={{ fontSize: '11px', color: '#6D89AF', cursor: 'pointer', display: 'block', marginBottom: '5px' }}
                                        onClick={() => openInNewTab('/terms_and_conditions')}
                                    >
                                        {t('footer.termsAndConditions')}
                                    </span>
                                    <span
                                        className={'footer_smaller_items'}
                                        style={{ fontSize: '11px', color: '#6D89AF', cursor: 'pointer', display: 'block' }}
                                        onClick={() => openInNewTab('/cookie_policy')}
                                    >
                                        {t('footer.cookiePolicy')}
                                    </span>
                                </div>
                            </Grid>

                            <Grid xs={12}>
                                <div style={{ display: 'flex' }}>

                                    <img alt="" src={AppleAppstore}
                                        onClick={() => {
                                            window.open('https://apps.apple.com/us/app/withme/id6477915797', '_blank');
                                            gtag('event', 'appstore_apple_redirect', {
                                                'event_category': 'IOS App Download',
                                                'event_label': 'IOS App Download'
                                            });
                                        }}
                                        style={{ width: '130px', height: 'auto', margin: '5px 10px 0px -3px', cursor: 'pointer' }}
                                    />
                                    <img alt="" src={AndroidPlaystore}
                                        onClick={() => {
                                            window.open('https://play.google.com/store/apps/details?id=com.withmeapp', '_blank');
                                            gtag('event', 'appstore_android_redirect', {
                                                'event_category': 'Android App Download',
                                                'event_label': 'Android App Download'
                                            });
                                        }}
                                        style={{ width: '130px', height: 'auto', margin: '5px 0px 0px -3px', cursor: 'pointer' }}
                                    />
                                </div>
                            </Grid>


                            <Grid xs={12} style={{ display: 'flex', justifyContent: 'flex-start' }}>
                                <p style={{ fontSize: '10px', color: '#AFBED3' }}>{t('footer.allRightsReserved', { year: new Date().getFullYear() })}</p>
                            </Grid>
                        </Grid>
                }
            </Grid>

            <Suspense fallback={<></>}>
                <PricingModal
                    salesPage={true}
                    pricingModal={pricingModal}
                    handlePricingModalClose={handlePricingModalClose}
                    sectionHeader={sectionHeader}
                    mainHeader={mainHeader}
                    mainDescription={mainDescription}
                    windowWidth={windowWidth}
                />
            </Suspense>

            {calendlyModal && (
                <Suspense fallback={<></>}>
                    <PopupModal
                        url="https://calendly.com/sdr-team-9rc/fitwith-demo"
                        onModalClose={() => setCalendlyModal(false)}
                        open={calendlyModal}
                        rootElement={document.getElementById("root")}
                    />
                </Suspense>
            )}

            {
                registerIsLoading ?
                    <Modal open={registerIsLoading}>
                        <Box style={modalStyle}
                            sx={{
                                display: 'flex', width: '100%', height: '100%',
                                margin: 'auto'
                            }}>
                            <Grid
                                container
                                spacing={0}
                                direction="column"
                                alignItems="center"
                                justifyContent="center"
                                style={{ minHeight: '90vh' }}
                            >
                                <CircularProgress sx={{
                                    color: 'var(--brand-color)',
                                }} />

                                <p style={{
                                    color: 'var(--primary-text-color)', fontSize: 'var(--medium-text)',
                                    fontWeight: '600',
                                }}>{t('auth.register.creatingAccount')}</p>
                            </Grid>
                        </Box>
                    </Modal>
                    :
                    <div></div>
            }
        </div>
    );
}


const SSOButtons = (props) => {
    const processAppleSSO = (token, firstName, lastName, apiUrl) => {
        const form_data = new FormData()
        form_data.append('token', token)
        const realName = `${firstName} ${lastName}`
        const displayName = `${firstName}${lastName}`
        form_data.append('real_name', realName)
        form_data.append('display_name', displayName)
        axios.post(
            apiUrl,
            form_data,
            { withCredentials: true }
        ).then(res => {
            window.location.assign(res['data']['redirect_url'])
        }).catch(() => props.setRegisterIsLoading(false))
    }
    return (
        <Grid style={props.containerStyle ? props.containerStyle : {}}>
            <Button
                style={props.googleBtnStyle}
                onClick={
                    () => {
                        props.setRegisterIsLoading(true);
                        gtag('event', 'landing_page_social_signup_lead', {
                            'event_category': 'Lead',
                            'event_label': 'Landing Page Lead (Google)'
                        });
                        let site = 'fitwith'
                        if (window.location.origin.includes('withme.so')) {
                            site = 'withme'
                        }
                        if ((props.referralId != null) & (props.referralId != '')) {
                            window.location.assign(paths.BACKEND_URL + 'oauth/login/google-oauth2?next=/api/social/confirm_profile_direct_influencer/' + props.referralId + '/null/' + props.utmSource + '/' + props.utmMedium + '/' + props.utmCampaign + '/' + props.utmContent + '/' + props.utmTerm + '/' + site)
                        } else if ((props.passiveReferralId != null) & (props.passiveReferralId != '')) {
                            window.location.assign(paths.BACKEND_URL + 'oauth/login/google-oauth2?next=/api/social/confirm_profile_passive_influencer/' + props.passiveReferralId + '/' + props.utmSource + '/' + props.utmMedium + '/' + props.utmCampaign + '/' + props.utmContent + '/' + props.utmTerm + '/' + site)
                        } else {
                            window.location.assign(paths.BACKEND_URL + 'oauth/login/google-oauth2?next=/api/social/confirm_profile_passive_influencer/null/' + props.utmSource + '/' + props.utmMedium + '/' + props.utmCampaign + '/' + props.utmContent + '/' + props.utmTerm + '/' + site)
                        }
                    }
                }
            >
                <FcGoogle size={19} style={{ marginRight: '8px' }} /> {props.t('salesPage.signUpWithGoogle')}
            </Button>
            <Suspense fallback={<Button style={props.appleBtnStyle}><FaApple size={19} style={{ marginRight: '8px' }} /> {props.t('salesPage.signUpWithApple')}</Button>}>
                <AppleLogin
                    render={({ onClick }) =>
                        <Button
                            onClick={async () => {
                                window.deferApple && window.deferApple();
                                try { await waitUntilConditionIsTrue(() => window.AppleID && window.AppleID.auth); } catch {}
                                onClick();
                            }}
                            style={props.appleBtnStyle}>
                            <FaApple size={19} style={{ marginRight: '8px' }} /> {props.t('salesPage.signUpWithApple')}
                        </Button>
                    }
                    clientId="so.withme"
                    redirectURI={`${window.location.origin}/login`}
                    responseType="code id_token"
                    responseMode="query"
                    usePopup={true}
                    scope="name email"
                    callback={(res) => {
                        if (!res['error']) {
                            props.setRegisterIsLoading(true)
                            let site = 'fitwith'
                            if (window.location.origin.includes('withme.so')) {
                                site = 'withme'
                            }
                            const token = res['authorization']['id_token']
                            let firstName = null
                            let lastName = null
                            if (res['user']) {
                                // User's email and name only returned the first time, or after unlinking in apple id settings
                                firstName = res['user']['name']['firstName']
                                lastName = res['user']['name']['lastName']
                            }
                            if ((props.referralId != null) & (props.referralId != '')) {
                                const apiUrl = paths.BACKEND_URL + 'api/social/confirm_profile_influencer_direct_apple/'
                                    + props.referralId + '/null/' + props.utmSource + '/' + props.utmMedium + '/' + props.utmCampaign + '/' + props.utmContent + '/' + props.utmTerm + '/' + site
                                processAppleSSO(token, firstName, lastName, apiUrl)
                            } else if ((props.passiveReferralId != null) & (props.passiveReferralId != '')) {
                                const apiUrl = paths.BACKEND_URL + 'api/social/confirm_profile_influencer_passive_apple/'
                                    + props.passiveReferralId + '/' + props.utmSource + '/' + props.utmMedium + '/' + props.utmCampaign + '/' + props.utmContent + '/' + props.utmTerm + '/' + site
                                processAppleSSO(token, firstName, lastName, apiUrl)
                            } else {
                                const apiUrl = paths.BACKEND_URL + 'api/social/confirm_profile_influencer_passive_apple/'
                                    + 'null' + '/' + props.utmSource + '/' + props.utmMedium + '/' + props.utmCampaign + '/' + props.utmContent + '/' + props.utmTerm + '/' + site
                                processAppleSSO(token, firstName, lastName, apiUrl)
                            }
                        }
                    }}
                />
            </Suspense>
        </Grid>
    )
}
